import { Navigate, useParams } from 'react-router-dom'
import { ENPI_MESSSTELLEN_BASE_PATH } from './enpi-paths'

/**
 * Used only by the legacy `/measures/enpi/:enpiId` and `/measures/enpi/:enpiId/edit` routes when
 * easy-offer-enpi is ON, so existing bookmarks/emailed links/deep links keep working.
 *
 * Both callers declare `:enpiId` as a required route segment (no `?`), so React Router only ever
 * renders this component when it's present in the URL - `useParams` can't express that per-route
 * guarantee in its types (it always widens to `string | undefined`), hence the single assertion
 * here rather than pushing an unreachable undefined case into every `suffix` callback.
 */
export const EnpiLegacyRedirect = ({ suffix }: { suffix: (params: { enpiId: string }) => string }) => {
  const { enpiId } = useParams<{ enpiId: string }>()
  return <Navigate replace to={`${ENPI_MESSSTELLEN_BASE_PATH}${suffix({ enpiId: enpiId! })}`} />
}
